import type RecipientEditorViewState from "owa-recipient-types/lib/types/RecipientEditorViewState";
import { mutatorAction } from "satcheljs";

/**
 * Change recipientsChangedStamp to force an update
 * @param recipientEditor RecipientEditorViewState
 */
const refreshRecipientsMutator: (recipientEditor: RecipientEditorViewState) => void = mutatorAction("refreshRecipients", (recipientEditor: RecipientEditorViewState): void => {
    recipientEditor.recipientsChangedStamp = Date.now();
});
export default refreshRecipientsMutator;
